export default function stickyNav() {
    const navs = document.querySelectorAll('.js--sticky-nav');

    if (!navs.length) return;

    const initStickyNav = (nav) => {
        const sentinel = nav.querySelector('.sticky-nav__sentinel');
        const wrap = nav.querySelector('.sticky-nav__wrap');
        if (document.getElementById('header-nav')) nav.classList.add('sticky-nav_with-menu');

        const isNavWithLowerTop = nav.classList.contains('sticky-nav_top_lower');
        if (isNavWithLowerTop) sentinel.style.height = `calc(100% - 100vh - ${wrap.offsetHeight + wrap.offsetTop}px)`;
        else sentinel.style.height = `calc(100% - 100vh - ${wrap.offsetHeight}px)`;
        wrap.style.width = `${wrap.offsetWidth}px`;

        const callback = ([entry]) => {
            const { isIntersecting, boundingClientRect } = entry;
            if (isIntersecting) {
                wrap.classList.add('is-sticky');
                wrap.classList.remove('is-bottom');
            } else {
                wrap.classList.remove('is-sticky');
                wrap.classList.remove('is-bottom');
                if (Math.sign(boundingClientRect.top) === -1) wrap.classList.add('is-bottom');
            }
        };

        const observer = new IntersectionObserver(callback, {
            rootMargin: '0px',
            threshold: 0
        });

        observer.observe(sentinel);
    };

    navs.forEach((nav) => {
        initStickyNav(nav);
    });
}
